/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as o from "react";
import { Popup as c } from "@progress/kendo-react-popup";
import { classNames as a } from "@progress/kendo-react-common";
const m = "bottom", r = "top", s = (e) => {
  const n = e.popupSettings || {}, t = e.dir === "rtl" ? "right" : "left", i = o.useMemo(
    () => ({ horizontal: t, vertical: m }),
    [t]
  ), l = o.useMemo(
    () => ({ horizontal: t, vertical: r }),
    [t]
  );
  return /* @__PURE__ */ o.createElement(o.Fragment, null, e.input, e.button, !e._mobileMode && /* @__PURE__ */ o.createElement(
    c,
    {
      style: {
        ...(n || {}).style,
        direction: e.dir
      },
      ...n,
      anchor: e.popupAnchor,
      anchorAlign: i,
      popupAlign: l,
      show: e.open,
      onOpen: e.onOpen,
      onClose: e.onClose,
      className: a(n.className),
      popupClass: "k-colorpicker-popup"
    },
    e.content
  ), e._mobileMode && e._actionSheet);
};
s.displayName = "KendoPickerComponent";
export {
  s as Picker
};
